import Api from "../../../../service";
import { SET_ERROR, SET_NATIONALTEAMTOPSCORERS, getKey } from "./constants";

const setNationalTeamTopScorers = (data, key) => ({
  type: SET_NATIONALTEAMTOPSCORERS,
  data,
  key,
});

const setError = (data, key) => ({
  type: SET_ERROR,
  data,
  key,
});

export const getNationalTeamTopScorers = (data) => (dispatch) =>
  Api.nationalTeam
    .getNationalTeamTopScorers(data)
    .then((response) => {
      dispatch(setNationalTeamTopScorers(response, getKey(data)));
      return response;
    })
    .catch((error) => {
      console.error(error);
      dispatch(setError(error, getKey(data)));
    });
